import { CalculationMethod, SaleDocumentKind } from '@skylab-shared/dataModel';
import { DocumentAdjustmentCalculator, DocumentAdjustmentGrossCalculator, DocumentAdjustmentNetCalculator, DocumentCalculator, DocumentGrossCalculator, DocumentNetCalculator } from '@skylab/calculations/document';
import { AdvanceInvoiceAdjustmentDocumentGrossCalculator, AdvanceInvoiceDocumentGrossCalculator, AdvanceInvoiceDocumentNetCalculator, AdvanceInvoiceNetAdjustmentDocumentCalculator } from '../../documents/algorithms/document/advance-invoice-document-calculator';
import { SaleDocumentAdjustmentMarginCalculator, SaleDocumentMarginCalculator } from '../../documents/algorithms/document/sale-document-margin-calculator';

const calculatorMap = {
    [SaleDocumentKind.Invoice]: {
        [CalculationMethod.Net]: DocumentNetCalculator,
        [CalculationMethod.Gross]: DocumentGrossCalculator
    },
    [SaleDocumentKind.InvoiceAdjustment]: {
        [CalculationMethod.Net]: DocumentAdjustmentNetCalculator,
        [CalculationMethod.Gross]: DocumentAdjustmentGrossCalculator
    },
    [SaleDocumentKind.Receipt]: {
        [CalculationMethod.Gross]: DocumentGrossCalculator
    },
    [SaleDocumentKind.ReceiptAdjustment]: {
        [CalculationMethod.Net]: DocumentAdjustmentNetCalculator,
        [CalculationMethod.Gross]: DocumentAdjustmentGrossCalculator
    },
    [SaleDocumentKind.ProForma]: {
        [CalculationMethod.Net]: DocumentNetCalculator,
        [CalculationMethod.Gross]: DocumentGrossCalculator
    },
    [SaleDocumentKind.VatMarginInvoice]: {
        [CalculationMethod.Margin]: SaleDocumentMarginCalculator
    },
    [SaleDocumentKind.VatMarginInvoiceAdjustment]: {
        [CalculationMethod.Margin]: SaleDocumentAdjustmentMarginCalculator
    },
    [SaleDocumentKind.AdvanceInvoice]: {
        [CalculationMethod.Gross]: AdvanceInvoiceDocumentGrossCalculator,
        [CalculationMethod.Net]: AdvanceInvoiceDocumentNetCalculator
    },
    [SaleDocumentKind.AdvanceInvoiceAdjustment]: {
        [CalculationMethod.Gross]: AdvanceInvoiceAdjustmentDocumentGrossCalculator,
        [CalculationMethod.Net]: AdvanceInvoiceNetAdjustmentDocumentCalculator
    },
};

export function getDocumentCalculatorForSaleDocumentKind(documentKind: SaleDocumentKind.VatMarginInvoice, calculationMethod: CalculationMethod, vatPayer: boolean): DocumentCalculator | DocumentAdjustmentCalculator;
export function getDocumentCalculatorForSaleDocumentKind(documentKind: SaleDocumentKind, calculationMethod: CalculationMethod, vatPayer: boolean): DocumentCalculator | DocumentAdjustmentCalculator;
export function getDocumentCalculatorForSaleDocumentKind(documentKind: SaleDocumentKind, calculationMethod: CalculationMethod, vatPayer: boolean): DocumentCalculator | DocumentAdjustmentCalculator {
    const kindMap = calculatorMap[documentKind] as Record<CalculationMethod, any>;
    const calculator = [SaleDocumentKind.VatMarginInvoice, SaleDocumentKind.VatMarginInvoiceAdjustment].includes(documentKind)
        ? kindMap[calculationMethod]
        : kindMap[vatPayer ? calculationMethod : CalculationMethod.Gross];
    if (!calculator)
        throw new Error(`Unexpected document kind.`);
    return new calculator();
}

export function getCalculationMethodsForSaleDocumentKind(kind: SaleDocumentKind): CalculationMethod[] {
    switch (kind) {
        case SaleDocumentKind.Invoice: return [CalculationMethod.Net, CalculationMethod.Gross];
        case SaleDocumentKind.ProForma: return [CalculationMethod.Net, CalculationMethod.Gross];
        case SaleDocumentKind.VatMarginInvoice: return [CalculationMethod.Margin];
        case SaleDocumentKind.Receipt: return [CalculationMethod.Gross];
        case SaleDocumentKind.AdvanceInvoice: return [CalculationMethod.Gross, CalculationMethod.Net];
        default: throw new RangeError();
    }
}
